import React from "react";

export default function Footer() {
    return (
        <div className="text-slate-400 font-extralight text-sm  text-center p-5 bg-slate-900">
            Footer
        </div>
    );
}
